import React, {Component} from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import axios from "axios";
import {authService} from "../../../auth";
import * as _ from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import {setProjectDetails} from "../../../reducer/showAllReducer";
import {connect} from "react-redux";
import AutoComplete from "../../component/commons/Autocomplete";
import {WithContext as ReactTags} from "react-tag-input";
import OutSideWNEmailConfirmPopUp from "../../../commons/OutSideWNEmailConfirmPopUp";
import uuid from "react-uuid";
import {Link, NavLink} from "react-router-dom";
import mappingUtils from "../../component/commons/utils/mappingUtils";
import ReactTooltip from "react-tooltip";
import { getCDNUrl } from "../../../commons/CommonFunctions";
import withReactContent from "sweetalert2-react-content";
import alertPopUp from "sweetalert2";
import SendMessageModal from "../../../commons/SendMessageModal";
import SearchZeroDataSection from "../../../commons/SearchZeroDataSection";
import AllowRestrictRemoveBtn from "./AllowRestrictRemoveBtn";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import CleverTapUtils from "../../../commons/CleverTapUtils";
const ErorrMsgPopUp = withReactContent(alertPopUp);

class ParticipantsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            participants: [],
            pendingParticipants: [],
            offlinePendingParticipants: [],
            pageSize: 6,
            pageNo: 0,
            pagination: false,
            pendingPageSize: 6,
            pendingPageNo: 0,
            pendingPagination: false,
            requestedPendingPagination: false,
            isPendingResultLoading: true,
            project: props.project,
            pendingParticipantsFetched: false,
            isOffline: false,
            faculties: [],
            outsideWNEmails: '',
            tags: [],
            hashtagKey: "outsideWN",
            sendOutSideWNEmailDisabled: true,
            messageEmailSent: "",
            projectDetail: {},
            uniqueKeyInvite: uuid(),
            uniqueKeyPending: uuid(),
            currentIndex: '',
            type:this.props.projectDetail.participationDetails.secondaryEntityType,
            subscriptionConfig:{},
            subscriptionError:false,
            subscriptionErrorMessage:'',
            openSendMessageModal: null,
            participantsSearchData: "",
            searchFlag: false,
            responseMessage: "",
            donationEntityConfig: {}
        }


        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);

    }

    openAcceptModal = (id) => {
        window.$('#Accept' + id).modal('show');
    }

    componentWillUnmount() {
        window.$('#confirmPopupInvite' + this.state.uniqueKeyInvite + this.state.currentIndex).modal('hide');
        window.$('#projectDetails').modal('hide');
        window.$('#confirmPopupPending' + this.state.uniqueKeyPending).modal('hide')
        this.state.pendingParticipants && this.state.pendingParticipants.map((user, index) => {
            if (window.$('#Accept' + user.id)) {
                window.$('#Accept' + user.id).modal('hide');
            }
        });
        window.$('#newInvitepeople').modal('hide');
        window.$('.modal-backdrop').remove();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.projectDetail !== nextProps.projectDetail) {
            this.setState({'projectDetail': nextProps.projectDetail}, () => {
                this.getFacultiesSuggestion();
                window.$(".outsdinvfrndhdr").click(function () {
                    window.$(".outsdinvfrndbdy").slideToggle("slow");
                    window.$(".outsdinvfrndhdr").toggleClass("active");
                });

            });
        }

    }

    confirmModalInvite = (event, index) => {
        event.preventDefault();
        this.setState({'currentIndex': index}, () => {
            window.$('#confirmPopupInvite' + this.state.uniqueKeyInvite + this.state.currentIndex).modal('show')
        })

    }

    ignoreModalInvite = () => {
        window.$('#confirmPopupInvite' + this.state.uniqueKeyInvite + this.state.currentIndex).modal('hide')
    }

    confirmModalPending = (event, index) => {
        event.preventDefault();
        this.setState({'currentIndex': index}, () => {
            window.$('#confirmPopupPending' + this.state.uniqueKeyPending + this.state.currentIndex).modal('show')
        })

    }

    ignoreModalPending = () => {
        window.$('#confirmPopupPending' + this.state.uniqueKeyPending + this.state.currentIndex).modal('hide')
    }

    handleDelete(i) {
        const {tags} = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        }, () => {
            if (this.state.tags.length > 0 && this.state.tags.length < 11) {
                this.setState({'sendOutSideWNEmailDisabled': false});
            } else {
                this.setState({'sendOutSideWNEmailDisabled': true});
            }
        });
    }


    handleAddition = (tag) => {
        this.isEmail(tag);
    }

    isEmail = (tag) => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regEmail.test(tag)) {
            return null;
        } else {
            this.verifyWenatMember(tag);
        }
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        this.setState({tags: newTags});
    }


    componentDidMount() {
        window.$(".outsdinvfrndhdr").click(function () {
            window.$(".outsdinvfrndbdy").slideToggle("slow");
            window.$(".outsdinvfrndhdr").toggleClass("active");
        });
        this.getApprovedParticipants(false, true);
        this.handlePendingParticipants();
        this.getFacultiesSuggestion();
        this.getSubscriptionEntityConfig();

        window.$('.projgeneralsec .collapse').on('shown.bs.collapse', function () {
            window.$(this).parent().addClass('active');
        });

        window.$('.projgeneralsec .collapse').on('hidden.bs.collapse', function () {
            window.$(this).parent().removeClass('active');
        });
    }

    getSubscriptionEntityConfig = () => {
        let postBody = {
            "userId": (this.props.projectDetail && this.props.projectDetail.superAdminId) || (this.props.projectDetail && this.props.projectDetail.creatorUserId) || authService.getUserDetailsFromLocalStorage().userId,
            "entityId": this.props.projectId,
            "entityType": 'PROJECT',

        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL +
                "/user/subscription/entity/config" ,
            data: postBody,
            headers: {'Content-Type': 'application/json'},

            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'subscriptionConfig': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
            this.setState({
                isLoaded: true
            });
        });
    };

    onChangeHandlerByNameAndValue = (name, value, imgUrl, id,userType) => {
        let e = {target: {}};
        e["target"]["name"] = name;
        e["target"]["value"] = value;
        e["target"]["url"] = imgUrl;
        e["target"]["id"] = id;
        e["target"]["userType"] = userType;

        this.onChangeHandler(e);
    };


    onChangeHandler = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let url = event.target.url;
        let id = event.target.id;
        let userType = event.target.userType;
        this.setFormFieldValue(name, value, url, id,userType);
    };

    setFormFieldValue = (name, value, url, id,userType) => {
        if (name == "participant") {
            let participants = this.state.faculties.filter(
                (participant) => participant.id.toLowerCase().indexOf(id.toLowerCase()) < 0
            );

            participants.push({value, url, id,userType});
            this.setState({faculties: participants});
            this.setState({
                'facultiesSuggestion': this.state.facultiesSuggestion.filter(
                    (fac) => {
                        return id !== fac.id;
                    }
                )
            })
        }
    };

    removeParticipants(faculty) {
        this.setState({
            faculties:
                this.state.faculties.filter(
                    (fac) => {
                        return faculty.id !== fac.id;
                    }
                ),

        });
        let facultiesSuggestion = this.state.facultiesSuggestion;
        faculty.img = faculty.url;
        facultiesSuggestion.push(faculty);
        this.setState({'facultiesSuggestion': facultiesSuggestion});
    }


    getFacultiesSuggestion = () => {

        let userData = authService.getUserDetailsFromLocalStorage();
        let url = process.env.REACT_APP_userServiceURL + '/participants/find-project-participants-suggestions/' + this.props.projectId + '/' + userData.userId + '/' + this.state.userData.userId + '/' + this.props.type+'/'+mappingUtils.getPartyType(this.props.projectDetail.partyType);

        axios({
            method: 'get',
            url: url,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                let userInfos = (response.data.body);
                let faculties = [];
                userInfos.map((userInfo) => {
                    let user = {
                        value: userInfo.username,
                        img: userInfo.imageUrl && !_.isNull(userInfo.imageUrl) ? userInfo.imageUrl : mappingUtils.returnDefaultImage(userInfo.type),
                        id: userInfo.id,
                        type:userInfo.type
                    };
                    faculties.push(user);
                });
                this.setState({facultiesSuggestion: faculties, participantSuggestion: faculties});

            }
        }).catch((err) => {
            console.log(err);
        });

    };

    removefaculties = (event) => {
        event.preventDefault();
        this.setState({'faculties': [],'inputReset':true});
        this.getFacultiesSuggestion();

    };


    handlePendingParticipants = () => {
        if (!this.state.pendingParticipantsFetched) {
            this.getRequestedPendingParticipants(true);
            this.getPendingParticipants(true);
        }

    };


    fetchMoreData = () => {
        this.setState({isResultLoading: true, pageNo: this.state.pageNo + 1}, () => {
            this.getApprovedParticipants(false, true);
        })
    };

    redirectToProfile = (customUrl) => {
        window.location.href = "/profile/" + customUrl;
    }

    inviteNewParticipants = () => {
        CleverTapUtils.eventClick({}, "Invite New Participants");
        if(this.state.subscriptionConfig && this.state.subscriptionConfig.privateProjectSubscriptionExpired){
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>{!this.isSuperAdmin() ? 'Please ask super admin to take subscription. Contact Super Admin.':'Please take subscription.'}</p>{!this.isSuperAdmin() ? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                })
            })
        }else if(this.state.subscriptionConfig && !this.state.subscriptionConfig.canInviteParticipants){
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>{!this.isSuperAdmin() ? 'Reached maximum number of invitations allowed. Contact Super Admin.':'You have reach the maximum limit for inviting participants in Project.'}</p>{!this.isSuperAdmin() ? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                })
            })
        }else{
            this.checkOpeningsAvailable();
        }

    }
    checkOpeningsAvailable = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/project/check-openings?projectId=' + this.props.projectId ,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data) {
                if(response.data.body){
                    window.$('#newInvitepeople').modal('show');
                }else{
                    window.$('#invalidNoOfOpenings').modal('show');
                }

            }
        }).catch((err) => {
            console.log(err);
        });
    };



    fetchMorePendingData = () => {
        this.setState({isPendingResultLoading: true, pendingPageNo: this.state.pendingPageNo + 1}, () => {
            this.getPendingParticipants(false);
        })

    };

    fetchMoreOfflinePendingData = () => {
        this.setState({isPendingResultLoading: true, pendingPageNo: this.state.pendingPageNo + 1}, () => {
            this.getRequestedPendingParticipants(false);
        })

    };


    getApprovedParticipants = (renew, checkSearchFlag) => {
        this.setState({responseMessage: ""})
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_userServiceURL}/participants/find-project-participants-details-by-projectId/${this.props.projectId}?userId=${this.state.userData.userId}&page=${this.state.pageNo}&size=${this.state.pageSize}&query=${this.state.participantsSearchData}`,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                let participants
                if (renew) {
                    participants = [];
                } else {
                    participants = this.state.participants;
                }

                participants.push(...response.data.body.content);
                this.setState({
                    'participants': participants,
                    'pagination': !response.data.body.last,
                    isResultLoading: false,
                    responseMessage: response.data.message
                });
                if(checkSearchFlag && participants.length > 6 && this.state.pageNo === 1) {
                    this.setState({
                        searchFlag: true
                    })
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getPendingParticipants = (renew) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/participants/find-project-pending-participants-details-by-projectId/'
                + this.props.projectId +"?userId="+this.state.userData.userId+ "&page=" + this.state.pendingPageNo + "&size=" + this.state.pendingPageSize,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                let participants;
                if (renew) {
                    participants = [];
                } else {
                    participants = this.state.pendingParticipants;
                }
                participants.push(...response.data.body.content);
                this.setState({
                    'pendingParticipants': participants,
                    'pendingPagination': !response.data.body.last,
                    isPendingResultLoading: false
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    getRequestedPendingParticipants = (renew) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/participants/find-offline-project-pending-participants-details-by-projectId/'
                + this.props.projectId +"?userId="+this.state.userData.userId+ "&page=" + this.state.pendingPageNo + "&size=" + this.state.pendingPageSize,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            let offlinePendingParticipants;
            if (renew) {
                offlinePendingParticipants = [];
            } else {
                offlinePendingParticipants = this.state.offlinePendingParticipants;
            }
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                offlinePendingParticipants.push(...response.data.body.content);
                this.setState({
                    'offlinePendingParticipants': offlinePendingParticipants,
                    'requestedPendingPagination': !response.data.body.last,
                    isPendingResultLoading: false
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    handleSubmit(event, data, stage) {
        event.preventDefault();
        let postBody = {
            "id": data.id,
            "approverId": this.state.userData.userId,
            "otherParticipatingUserId": data.otherParticipantUserId,
            "projectId": this.props.projectId,
            "stage": stage
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/participants/update',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                window.$('#Accept' + data.id).modal('hide');
                this.setState({
                    'pendingPageNo': 0,
                    'pendingPageSize': 6,
                    'pageNo': 0,
                    'pageSize': 6,
                    'pendingParticipantsFetched': false
                }, () => {
                    this.handlePendingParticipants();
                    this.getApprovedParticipants(true);
                    this.ignoreModalInvite();
                })
            }
        }).catch((err) => {

        });

    };

    verifyWenatMember = (tag) => {
        if(this.checkDuplicate(tag)){
            let {tags} = this.state;
            let emails = [];
            emails.push(tag);
            axios({
                method: 'get',
                url: process.env.REACT_APP_userServiceURL + '/participants/verify/wenatmember/' +
                    "?emails=" + emails,
                headers: {'Content-Type': 'application/json'},
                withCredentials: true
            }).then(response => {
                if (response && response.data && response.data.body && response.data.message === 'Success!') {
                    if (response.data.body.length > 0) {
                        this.setState({'messageEmailSent': response.data.body + ' is already a member at WeNaturalists'}, () => {
                            window.$('#outsideWNEmailerConfirmPopUp').modal('show');
                        });
                    } else {
                        this.setState({tags: [...this.state.tags, {id: tags.length + 1, text: tag}]}, () => {
                            if (this.state.tags.length > 0 && this.state.tags.length < 11) {
                                this.setState({'sendOutSideWNEmailDisabled': false});
                            } else {
                                this.setState({'sendOutSideWNEmailDisabled': true});
                            }
                        });
                    }

                }
            }).catch((err) => {
                console.log(err);
            });
        }
    };

    sendEmailToOutsideWN = (event) => {
        event.preventDefault();
        this.setState({'sendOutSideWNEmailDisabled': true});
        let emails = [];
        this.state.tags.forEach((tag) => {
            emails.push(tag.text);
        })
        let maxParticipants = this.state.subscriptionConfig.maxParticipantsOutsideWN - this.state.subscriptionConfig.outsideWenatParticipants;
        if(emails.length<=maxParticipants) {
        let postBody = {
            "emails": emails,
            "invitationType" : "PARTICIPATION",
            "approverId": this.state.userData.userId,
            "projectId": this.props.projectId,
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/participation/outside/save',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                this.setState({'sendOutSideWNEmailDisabled': true, 'tags': []});
                this.setState({'messageEmailSent': 'Invitation has been sent successfully.'}, () => {
                    window.$('#outsideWNEmailerConfirmPopUp').modal('show');
                });
                this.getSubscriptionEntityConfig();
            }
        }).catch((err) => {
            console.log('error message' + err);
            this.setState({'sendOutSideWNEmailDisabled': false});
            this.setState({'messageEmailSent': err.response.data.message});
            window.$('#outsideWNEmailerConfirmPopUp').modal('show');
        });
        } else{
            if(this.state.subscriptionConfig && this.state.subscriptionConfig.privateProjectSubscriptionExpired){
                ErorrMsgPopUp.fire({
                    didOpen: () => {
                        ErorrMsgPopUp.clickConfirm();
                    }
                }).then((result) => {
                    return ErorrMsgPopUp.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: <><p>{!this.isSuperAdmin() ? 'Please ask super admin to take subscription. Contact Super Admin.':'Please take subscription.'}</p>{!this.isSuperAdmin() ? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                    })
                })
            }
            else if(maxParticipants == 0){
                ErorrMsgPopUp.fire({
                    didOpen: () => {
                        ErorrMsgPopUp.clickConfirm();
                    }
                }).then((result) => {
                    return ErorrMsgPopUp.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: <><p>{!this.isSuperAdmin() ? 'Reached maximum number of invitations allowed. Contact Super Admin.':'You have reached the maximum limit for inviting friends from outside WeNaturalists.'}</p>{!this.isSuperAdmin() ? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                    })
                })
            }else{
                ErorrMsgPopUp.fire({
                    didOpen: () => {
                        ErorrMsgPopUp.clickConfirm();
                    }
                }).then((result) => {
                    return ErorrMsgPopUp.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: <><p>{!this.isSuperAdmin()?'You can not send more than '+maxParticipants+' as per subscription policy.Contact Super Admin.':'You can not send more than '+maxParticipants+' as per subscription policy.'}</p>{!this.isSuperAdmin()? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                    })
                })
            }
            /*this.setState({'sendOutSideWNEmailDisabled': false, 'messageEmailSent':maxParticipants>0? 'you can not send more than '+maxParticipants+' as per subscription policy':'You have reached the maximum limit for inviting friends from outside WeNaturalists. Upgrade your Membership.'});
            window.$('#outsideWNEmailerConfirmPopUp').modal('show');*/
        }

    };

    getOptimizedImage(project) {
        if (project.resizedImages && project.resizedImages['300x300'] != null) {
            return project.resizedImages['300x300'];
        }
        return project.coverImage;
    }

    updateProjectPermission=(event,type)=>{
        let project = this.state.project;
        project.project.projectParticipantPermission[type]=event.target.checked;
        this.setState({project:project});

        let postData={
            projectId: project.project.id,
            projectParticipantPermission: project.project.projectParticipantPermission

        }
        axios({
            method:'post',
            url:process.env.REACT_APP_userServiceURL + '/backend/managecirclepermission/update/project/participant/permission',
            headers:{ 'Content-Type': 'application/json' },
            data:postData,
            withCredentials: true
        }).then((response)=>{
            let res = response.data
            if(res && res.status === '202 ACCEPTED'){


            }
        }).catch((err)=>{
            console.log(err)

        })
    }


    sendParticipantRequest = (event) => {
        event.preventDefault();
        let title;
        let projectCreatorId;
        let projectType;
        let proj = this.props.projectDetail && this.props.projectDetail.project;
        if (proj) {
            title = proj.jobTitle || proj.sessionTitle || proj.assignmentTitle || proj.jobTitle || proj.title;
            if (this.props.projectDetail && this.props.projectDetail.participationDetails && this.props.projectDetail.participationDetails.creatorUserId && this.props.projectDetail.participationDetails.creatorUserId === this.state.userData.userId) {
                projectCreatorId = this.props.projectDetail.participationDetails.creatorUserId;
            } else {
                projectCreatorId = proj.userId;
            }
            projectType = this.props.projectDetail && this.props.projectDetail.participationDetails && this.props.projectDetail.participationDetails.secondaryEntityType;
        }

        let userIds = [];
        for (let data of this.state.faculties) {
            userIds.push(data.id);
        }
        let maxParticipants = this.state.subscriptionConfig.maxParticipants - this.state.subscriptionConfig.inviteParticipants;
        if(userIds.length<=maxParticipants) {
            event.preventDefault();
            let postBody = {

                "projectId": this.props.projectId,
                //"projectCreatorId": projectCreatorId,
                "projectCreatorId": this.state.userData.userId,
                "title": title,
                "userIds": userIds,
                "projectType": projectType
            };
            axios({
                method: 'post',
                url: process.env.REACT_APP_userServiceURL + '/backend/participation/offline/send/request',
                headers: {'Content-Type': 'application/json'},
                data: postBody,
                withCredentials: true
            }).then((response, dispatch) => {
                let res = response.data;
                if (res.status === '201 CREATED') {
                    this.setState({faculties: []});
                    window.$('#newInvitepeople').modal('hide');
                    this.getFacultiesSuggestion();
                    this.setState({
                        'pendingPageNo': 0,
                        'pendingPageSize': 6,
                        'pageNo': 0,
                        'pageSize': 6,
                        'pendingParticipantsFetched': false
                    }, () => {
                        this.handlePendingParticipants();
                        this.getApprovedParticipants(true);
                        this.getSubscriptionEntityConfig();
                    })
                }
            }).catch((err) => {

            });
        }else{
            ErorrMsgPopUp.fire({
                didOpen: () => {
                    ErorrMsgPopUp.clickConfirm();
                }
            }).then((result) => {
                return ErorrMsgPopUp.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: <><p>{!this.isSuperAdmin()?'You can not send more than '+maxParticipants+' as per subscription policy.Contact Super Admin.':'You can not send more than '+maxParticipants+' as per subscription policy.'}</p>{!this.isSuperAdmin() ? <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClick(); }}>Send Message</a> : <><a class="styleBtn" href={'/wenaturalists-pro'}>Upgrade your Membership</a>{/* <div className='registerFreetrial'><a href='/wenaturalists-pro'>Register for a Free Trial</a></div> */}</>}</>,
                })
            })
            /*this.setState({'subscriptionError': true, 'subscriptionErrorMessage':maxParticipants>0? 'You can not send more than '+maxParticipants+' participant request as per subscription policy':'You have reach the maximum limit for inviting participants in Project. Upgrade your Membership.'});
            setTimeout(() => {
                this.setState({'subscriptionError': false, 'subscriptionErrorMessage':''});
            }, 5000);*/

        }

    };

    deleteParticipantRequest = (event, data) => {
        event.preventDefault();
        let postBody = {
            "projectId": this.props.projectId,
            "id": data.id
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/participation/offline/delete/request',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                this.setState({faculties: []});
                window.$('#newInvitepeople').modal('hide');
                this.getFacultiesSuggestion();
                this.setState({
                    'pendingPageNo': 0,
                    'pendingPageSize': 6,
                    'pageNo': 0,
                    'pageSize': 6,
                    'pendingParticipantsFetched': false
                }, () => {
                    this.handlePendingParticipants();
                    this.getApprovedParticipants(true);
                    this.ignoreModalPending()
                    this.getSubscriptionEntityConfig();
                })
            }
        }).catch((err) => {

        });

    };

    checkDuplicate= (emailId) => {
        let emails = [];
        this.state.tags.forEach((tag) => {
            emails.push(tag.text);
        })
        if(emails.includes(emailId)){
            this.setState({'messageEmailSent': 'Duplicate EmailId.'}, () => {
                window.$('#outsideWNEmailerConfirmPopUp').modal('show');
            });
            return false;
        }
        return true;
    }

    sendMessageButtonClick = () => {
        ErorrMsgPopUp.close();
        this.setState({openSendMessageModal: this.state.subscriptionConfig && this.state.subscriptionConfig.superAdminId});
    }

    triggerMessageModalClose = () => {
        this.setState({
            openSendMessageModal: null
        })
    }

    handleSearchParticipantsChange = (event) => {
        this.setState({
            participantsSearchData: event.target.value,
            pageNo: 0,
        },() => {
            this.getApprovedParticipants(true);
        })
    }

    handleSearchSubmit = (event) => {
        event.preventDefault();
        this.setState({
            pageNo: 0
        },() => {
            this.getApprovedParticipants(true);  
        })
    }

    isSuperAdmin = () => {
        if(this.props.projectDetail && this.props.projectDetail.superAdminId) {
            return (this.props.projectDetail.superAdminId === this.state.userData.userId);
        }
        if(this.props.projectDetail && this.props.projectDetail.creatorUserId) {
            return (this.props.projectDetail.creatorUserId === this.state.userData.userId);
        }
        return false;
    }

    onSuccessAllowRestrictPosting = (data, actionType) => {
        let participantList = this.state.participants;
        const index = participantList && participantList.findIndex((item) => item.userId === data.userId);
        if (index > -1) {
            if(actionType === "REMOVE") {
                participantList.splice(index, 1);
            } else {
                participantList[index].postingRestricted = !data.postingRestricted;
            }
        }
        this.setState({
            participant: participantList
        })
        if(participantList.length <= 5 && actionType === "REMOVE") {
            this.getApprovedParticipants(true);
        }
        this.forceUpdate();
    }

    getDonationConfig = (config) => {
        this.setState({
            donationEntityConfig: config
        })
    }

    sendMessageButtonClickModal = () => {
        window.$("#invalidNoOfOpenings").modal("hide");
        this.setState({sendMessageFlag: true});
    }

    triggerMessageModalCloseModal = () => {
        this.setState({sendMessageFlag: false});
    }

    render() {
        return (
            <div className="col-md-9">                
                <OutSideWNEmailConfirmPopUp messageEmailSent={this.state.messageEmailSent}/>
                <ReactTooltip
                    className="rtoolTip"
                    place="bottom"
                    id="participantOpening"
                    type="dark"
                    textColor="#00394D"
                    effect="solid"
                    backgroundColor="#ffffff">Openings became zero please edit the form and increase no of openings</ReactTooltip>
                <div className="projectinn nothidden projdetailscont pdperticipent">
                    <Banner {...this.props} needDonationConfig={true} getDonationConfig={this.getDonationConfig} pageType={"PARTICIPANT"} />
                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                    <TopBar {...this.props} />
                    }

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}
                    
                    <div className="projdetlswrap">
                        <div className="row">
                            <div className="col-lg-9">
                                <div id="accordion">
                                {(this.props.projectDetail && this.props.projectDetail && this.props.projectDetail.demolished && this.props.projectDetail.demolishedType === "DELETED" && this.props.type === "JOB"
                                    && this.props.projectDetail.demolishedDate &&
                                        this.props.projectDetail.demolishedDate > 0) && 
                                        <div className="projCancelWrap">
                                                <div className="imgbox"><img src="https://cdn.dscovr.com/images/zeroDeleteProject.webp"
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = "https://cdn.dscovr.com/images/zeroDeleteProject.png"
                                                                            }} style={{width: '250px'}} alt=""/>
                                                </div>
                                                <p>Project
                                                    was {this.props.projectDetail && this.props.projectDetail.demolishedType && this.props.projectDetail.demolishedType.toLowerCase()}
                                                    <span>on {new Date(this.props.projectDetail.demolishedDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit', month: 'short', year: 'numeric'
                                                    }).replace(/ /g, '-')}</span></p></div>

                                    } 
                                    {this.props.projectDetail && this.props.projectDetail.newApplicationsTabVisible &&
                                    <div className="card projgeneralsec pdnewapplication">
                                        <div className="card-header" id="heading-1">
                                            <a role="button" data-toggle="collapse" href="#collapse-1"
                                               aria-expanded="false" className="btn">{this.state.type !== 'FUNDRAISE'?'New Applications':'New Contributors'}</a>
                                        </div>
                                        <div id="collapse-1" className="collapse" data-parent="#accordion"
                                             aria-labelledby="heading-1">
                                            <div className="card-body">

                                                {!this.state.isOffline && this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                                <div className="">
                                                    {/* <h3>New Applicants</h3> */}
                                                    
                                                        <div id="scrollableDiv">
                                                            <div className="row">
                                                                {this.state.pendingParticipants && this.state.pendingParticipants.length > 0 && this.state.pendingParticipants.map((data, index) => {
                                                                    return <div className="col-md-6" key={index}>
                                                                        <div className= {"invitpeopleblk" + (data.userType === "COMPANY" ? " orgnzName" : "")}>
                                                                            <figure className="users" onClick={(e) => {e.preventDefault(); this.redirectToProfile(data.customUrl)}} style={{cursor: 'pointer'}}>
                                                                                <img
                                                                                    src={!_.isNull(data.profileImage) && !_.isUndefined(data.profileImage) ? data.profileImage : (data.userType != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                                                                                    alt=""/>
                                                                            </figure>
                                                                            <div>
                                                                                {/*<span className="pfollowlist">18 Jan 2020</span>*/}
                                                                                <h5><Link
                                                                                    to={"/profile/" + data.customUrl}
                                                                                    style={{cursor: 'pointer'}}>{data.userName}</Link>
                                                                                </h5>
                                                                                <p>
                                                                                    <span>{!_.isUndefined(data.country) && !_.isNull(data.country) && data.country}</span>
                                                                                    <span>{!_.isUndefined(data.persona) && !_.isNull(data.persona) && data.persona}</span>
                                                                                </p>
                                                                            </div>
                                                                            {this.props.projectDetail && this.props.projectDetail.editPermission &&
                                                                            <div className="invitpeopbtns">

                                                                                <ReactTooltip 
                                                                                    className="rtoolTip"
                                                                                    place="bottom"
                                                                                    id="participantOpening"
                                                                                    type="dark"
                                                                                    textColor="#00394D"
                                                                                    effect="solid"
                                                                                    backgroundColor="#ffffff">No of openings became zero please edit the project and increase no of openings</ReactTooltip> 
                                                                                <a href="javascript:void(0)" 
                                                                                   className="btn accept socialico m-0"
                                                                                   data-tip-disable={data.openingsAvailable}
                                                                                   data-tip="msg to show" 
                                                                                   data-for="participantOpening" 
                                                                                   data-place ='top' 
                                                                                   style={{ margin: '0',
                                                                                   cursor: !data.openingsAvailable && "not-allowed",
                                                                                        //    pointerEvents: !data.openingsAvailable?'none':'',
                                                                                           opacity: !data.openingsAvailable?0.6:''
                                                                                        }}
                                                                                   onClick={data.openingsAvailable && ((e) => this.openAcceptModal(data.id))}
                                                                                > Accept</a>

                                                                                <a href="javascript:void(0)"
                                                                                   onClick={((e) => this.confirmModalInvite(e, index))}
                                                                                   className="btn ignore">
                                                                                    IGNORE
                                                                                </a>
                                                                            </div>
                                                                            }
                                                                            {/*Confirmation New Apllicants Modal Start for accept button*/}
                                                                                <div
                                                                                    className="modal fade dgpopup confirmpop"
                                                                                    id={"Accept" + data.id}
                                                                                    tabIndex="-1" role="dialog"
                                                                                    aria-labelledby="exampleModalLabel"
                                                                                    aria-hidden="true" data-backdrop="static"
                                                                                    data-keyboard="false">
                                                                                    <div className="modal-dialog"
                                                                                        role="document">
                                                                                        <div className="modal-content">
                                                                                            <button type="button"
                                                                                                    className="close"
                                                                                                    data-dismiss="modal"
                                                                                                    aria-label="Close"><span
                                                                                                aria-hidden="true">&times;</span>
                                                                                            </button>
                                                                                            <div
                                                                                                className="confirm-popup-modal-body">
                                                                                                {/* Are you sure you want to accept request from {data.username}? */}
                                                                                                Are you sure you want to accept this request?
                                                                                            </div>
                                                                                            <div
                                                                                                className="modal-footer confirm-popup-modal-footer">
                                                                                                <button type="button"
                                                                                                        className="btn btn-primary"
                                                                                                        onClick={((e) => this.handleSubmit(e, data, 'PUBLISHED'))}
                                                                                                        >Yes
                                                                                                </button>
                                                                                                <button type="button"
                                                                                                        className="btn btn-secondary"
                                                                                                        data-dismiss="modal">No
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            {/*Confirmation New Apllicants Modal Start for ignore button*/}
                                                                            <div
                                                                                className="modal fade dgpopup confirmpop"
                                                                                id={"confirmPopupInvite" + this.state.uniqueKeyInvite + index}
                                                                                tabIndex="-1" role="dialog"
                                                                                aria-labelledby="exampleModalLabel"
                                                                                aria-hidden="true"
                                                                                data-backdrop="static"
                                                                                data-keyboard="false">
                                                                                <div className="modal-dialog"
                                                                                     role="document">
                                                                                    <div className="modal-content">
                                                                                        <button type="button"
                                                                                                className="close"
                                                                                                data-dismiss="modal"
                                                                                                aria-label="Close"><span
                                                                                            aria-hidden="true">&times;</span>
                                                                                        </button>
                                                                                        <div
                                                                                            className="confirm-popup-modal-body">
                                                                                                Are you sure you want to ignore this request?
                                                                                            {/* <span>{data.userName}</span>? */}
                                                                                        </div>
                                                                                        <div
                                                                                            className="modal-footer confirm-popup-modal-footer">
                                                                                            <button type="button"
                                                                                                    className="btn btn-primary"
                                                                                                    onClick={((e) => this.handleSubmit(e, data, 'DENIED'))}>Yes
                                                                                            </button>
                                                                                            <button type="button"
                                                                                                    className="btn btn-secondary"
                                                                                                    onClick={this.ignoreModalInvite}>No
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                })}
                                                            </div>
                                                        </div>
                                                        {this.state.pendingPagination &&
                                                        <div className="btnblock">
                                                            <Link className="btn" to={'/project/feeds/'+this.props.projectDetail.slug+'/new-applicants'}>
                                                                Show More
                                                            </Link>
                                                        </div>
                                                        }



                                                    {this.state.pendingParticipants && this.state.pendingParticipants.length === 0 && !this.state.isPendingResultLoading &&
                                                    <span className="noApplication">No Pending Applications</span>
                                                    }
                                                </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.props.projectDetail && this.props.projectDetail.pendingInvitationsVisible &&
                                    <div className="card projgeneralsec pdnewapplication">
                                        <div className="card-header" id="heading-2">
                                            <a role="button" data-toggle="collapse" href="#collapse-2"
                                               aria-expanded="false" className="btn">Pending Invitations</a>
                                        </div>
                                        <div id="collapse-2" className="collapse" data-parent="#accordion"
                                             aria-labelledby="heading-2">
                                            <div className="card-body">

                                                {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                                <div>
                                                    {/* <h3>Invite Sent</h3> */}
                                                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                                    <div ref={(ref) => this.scrollParentRef = ref}>
                                                        <div id="scrollableDiv">
                                                            {
                                                                this.state.offlinePendingParticipants && this.state.offlinePendingParticipants.length > 0
                                                                && <InfiniteScroll
                                                                    loadMore={this.fetchMoreOfflinePendingData.bind(this)}
                                                                    getScrollParent={() => this.scrollParentRef}
                                                                    hasMore={!this.state.isPendingResultLoading && this.state.requestedPendingPagination}
                                                                    loader={<h4 className='text-center'>Loading...</h4>}
                                                                >

                                                                    <div className="row">
                                                                        {this.state.offlinePendingParticipants && this.state.offlinePendingParticipants.length > 0 && this.state.offlinePendingParticipants.map((data, index) => {
                                                                            return <div className="col-md-6"
                                                                                        key={index}>
                                                                                <div className= {"invitpeopleblk" + (data.userType === "COMPANY" ? " orgnzName" : "")}>
                                                                                    <figure className="users"
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                this.redirectToProfile(data.customUrl)
                                                                                            }}
                                                                                            style={{cursor: 'pointer'}}>
                                                                                        <img
                                                                                            src={!_.isNull(data.profileImage) && !_.isUndefined(data.profileImage) ? data.profileImage : (data.userType != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                                                                                            alt=""/>
                                                                                    </figure>
                                                                                    <div>
                                                                                        {/*<span className="pfollowlist">18 Jan 2020</span>*/}
                                                                                        <h5><Link
                                                                                            to={"/profile/" + data.customUrl}
                                                                                            style={{cursor: 'pointer'}}>{data.userName}</Link>
                                                                                        </h5>
                                                                                        <p className="nviteBy">
                                                                                            <span>Invited By :</span>
                                                                                            <Link to={"/profile/" + data.senderCustomUrl} style={{cursor: 'pointer'}}>{data.senderUserName}</Link>
                                                                                        </p>
                                                                                        <p>
                                                                                            <span>{!_.isUndefined(data.country) && !_.isNull(data.country) && data.country}</span>
                                                                                            <span>{!_.isUndefined(data.persona) && !_.isNull(data.persona) && data.persona}</span>
                                                                                        </p>
                                                                                    </div>

                                                                                    {this.props.projectDetail && this.props.projectDetail.editPermission &&
                                                                                    <div
                                                                                        className="invitpeopbtns kcaninvbtn">
                                                                                        <a href="javascript:void(0)"
                                                                                           onClick={((e) => this.confirmModalPending(e, index))}
                                                                                           className="btn ignore">
                                                                                            Cancel Invite
                                                                                        </a>
                                                                                    </div>
                                                                                    }
                                                                                    {/*Confirmation Pending Modal Start*/}
                                                                                    <div
                                                                                        className="modal fade dgpopup confirmpop"
                                                                                        id={"confirmPopupPending" + this.state.uniqueKeyPending + index}
                                                                                        tabIndex="-1" role="dialog"
                                                                                        aria-labelledby="exampleModalLabel"
                                                                                        aria-hidden="true"
                                                                                        data-backdrop="static"
                                                                                        data-keyboard="false">
                                                                                        <div className="modal-dialog"
                                                                                             role="document">
                                                                                            <div
                                                                                                className="modal-content">
                                                                                                {/* <div className="modal-header">
                                                                                                    <h5 className="modal-title" id="exampleModalLabel">Connection Confirmation</h5>                                                                                                    
                                                                                                </div> */}
                                                                                                <button type="button"
                                                                                                        className="close"
                                                                                                        data-dismiss="modal"
                                                                                                        aria-label="Close"><span
                                                                                                    aria-hidden="true">&times;</span>
                                                                                                </button>
                                                                                                <div
                                                                                                    className="confirm-popup-modal-body">
                                                                                                    {/* <h5>Connection Confirmation</h5>   */}
                                                                                                    Are you sure you want to withdraw this invite?
                                                                                                    {/* <span>{data.userName}</span>? */}
                                                                                                </div>
                                                                                                <div
                                                                                                    className="modal-footer confirm-popup-modal-footer">
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-primary"
                                                                                                        onClick={((e) => this.deleteParticipantRequest(e, data))}>Yes
                                                                                                    </button>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-secondary"
                                                                                                        onClick={this.ignoreModalPending}>No
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {/*Confirmation Modal End*/}
                                                                                </div>
                                                                            </div>
                                                                        })}

                                                                    </div>
                                                                </InfiniteScroll>
                                                            }
                                                        </div>

                                                        {/*{this.state.requestedPendingPagination &&
                                                        <div className="btnblock">
                                                            <a href="javascript:void(0)"
                                                               onClick={this.fetchMoreOfflinePendingData}
                                                               className="btn" data-toggle="modal">
                                                                Show More
                                                            </a>
                                                        </div>
                                                        }*/}
                                                    </div>
                                                    }

                                                    {this.state.isOffline && this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false && this.state.offlinePendingParticipants && this.state.offlinePendingParticipants.length === 0 && !this.state.isPendingResultLoading &&
                                                    <span className="noApplication">No Pending Applications</span>
                                                    }
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>


                                {this.props.projectDetail &&
                                this.props.projectDetail.canInviteOutsideParticipants && this.props.projectDetail.participantTabVisible &&
                                this.state.type !== 'FUNDRAISE' &&
                                !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                <div className="pdpoutsdinvfrnd">

                                    <div className="outsdinvfrndhdr" onClick={() => {CleverTapUtils.eventClick({}, "Invite friends outside WeNaturalists");}}>

                                        <i className="iAdd_Group"></i><h4>Invite friends outside WeNaturalists</h4>
                                    </div>


                                    <div className="outsdinvfrndbdy">
                                        <ReactTooltip
                                            className="rtoolTip"
                                            place="bottom"
                                            id={'participantsTab'}
                                            type="dark"
                                            textColor="#00394D"
                                            effect="solid"
                                            backgroundColor="#ffffff">Action Restricted due to Subscription setting</ReactTooltip>
                                        <div className="tagfield">
                                            <ReactTags tags={this.state.tags}
                                                       key={this.state.hashtagKey}
                                                       handleDelete={this.handleDelete}
                                                       handleAddition={this.handleAddition}
                                                       disabled={this.state.tags.length === 10}
                                                       handleDrag={this.handleDrag}
                                                       placeholder="Write here..."/>
                                        </div>
                                        <div className="outsdinvfrndftr">
                                            <p>You can add up to 10 email addresses. Press "enter" after each email
                                                address.</p>
                                            <button className="btn send"
                                                    data-tip-disable={this.state.subscriptionConfig &&  this.state.subscriptionConfig.canSendOutsideWenatParticipants}
                                                    data-tip="msg to show" data-for={'participantsTab'}
                                                    data-place='bottom'
                                                    disabled={this.state.sendOutSideWNEmailDisabled}
                                                    onClick={this.sendEmailToOutsideWN}>Send Invite
                                            </button>
                                        </div>
                                    </div>
                                </div>}

                                {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false && this.props.projectDetail.applicationsTabVisible && this.props.projectDetail.participantTabVisible &&

                                <div className="projgeneralsec pdapplicationother">

                                    <div className="pdnewapplication d-flex justify-content-between"
                                         style={{padding: 0, background: 'transparent'}}>
                                        <h3 style={{textAlign: 'left', marginBottom: '8px'}}>{this.state.type === 'FUNDRAISE'?'Contributors':'Participants'}</h3>

                                        <div className="projpardtlbx">
                                            {this.state.isOffline && this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                            <h3>New Applicants</h3>}

                                            {this.props.projectDetail && this.props.projectDetail.participantTabVisible &&  this.props.projectDetail.canInviteParticipants && this.state.type !== 'FUNDRAISE' &&
                                            <div className="invtButtns">
                                                {/*<ReactTooltip
                                                    className="rtoolTip"
                                                    place="bottom"
                                                    id={'participantsTab'}
                                                    type="dark"
                                                    textColor="#00394D"
                                                    effect="solid"
                                                    backgroundColor="#ffffff">Action Restricted due to Subscription setting</ReactTooltip>*/}
                                                <a href="javascript:void(0)"
                                                  /* data-tip-disable={this.state.subscriptionConfig &&  this.state.subscriptionConfig.canInviteParticipants}
                                                   data-tip="msg to show" data-for={'participantsTab'}
                                                   data-place='bottom'*/
                                                   onClick={this.inviteNewParticipants}
                                                   className="btn addofflineproj"><i className="iAdd_Group"></i>{this.state.type === 'FUNDRAISE'?'Invite Contributors':'Invite New Participants'}</a>
                                                {/* Open Send Message Modal */}
                                                {this.state.openSendMessageModal && this.state.openSendMessageModal === this.state.subscriptionConfig.superAdminId &&
                                                    <SendMessageModal profileId={this.state.subscriptionConfig && this.state.subscriptionConfig.superAdminId}
                                                                        userName={this.state.subscriptionConfig && this.state.subscriptionConfig.username} 
                                                                        triggerMessageModalClose={this.triggerMessageModalClose}/>
                                                }
                                                <div id="newInvitepeople" className="modal fade dgpopup"
                                                     data-backdrop="static" data-keyboard="false">
                                                    <div className="modal-dialog">
                                                        <div className="modal-content">
                                                            <div className="modal-body">
                                                                <div className="newInvitepeopWrap">
                                                                    <button type="button" onClick={this.removefaculties}
                                                                            className="close" data-dismiss="modal"
                                                                            aria-label="Close"><span
                                                                        aria-hidden="true">&times;</span></button>
                                                                    <div className="pjaddjobsec addfaculty">
                                                                        <h4><i className="iAdd_Group"/> {this.state.type === 'FUNDRAISE'?'Add Contributors':'Add Participants'}
                                                                        </h4>
                                                                        <div className="form-group">
                                                                            <AutoComplete
                                                                                suggestions={
                                                                                    this.state.facultiesSuggestion
                                                                                }
                                                                                onChange={this.onChangeHandlerByNameAndValue}
                                                                                key="participant"
                                                                                inputReset={this.state.inputReset}
                                                                                name="participant">
                                                                                <input
                                                                                    autoComplete={"none"}
                                                                                    id={'autocompleteId'}
                                                                                    type="text"
                                                                                    className="form-control custom-input"
                                                                                    placeholder="Enter Name"
                                                                                />
                                                                            </AutoComplete>
                                                                            {this.state.facultiesSuggestion?.length === 0 && <div className="login-feedback-error mt-1" style={{ display: "block" }} ref={(node) => node?.style.setProperty("text-align", "center", "important")}>{this.state.userData?.type === "COMPANY" ? "You do not have any connections or community members to invite." : "You do not have any connections to invite."}</div>}
                                                                        </div>
                                                                        {this.state.faculties && this.state.faculties.length > 0 &&
                                                                        <div className="facultywrap">
                                                                            {this.state.faculties &&
                                                                            this.state.faculties.map((faculty) => {
                                                                                return (
                                                                                    <div className="facultyblk">
                                                                                        <div className= {"username" + ( faculty.userType === "COMPANY" ? " orgnzName" : "")}>
                                                                                            <figure className="user">
                                                                                                <img src={getCDNUrl(faculty.url)}
                                                                                                     alt=""/>
                                                                                            </figure>
                                                                                            <span>{" "}
                                                                                                {faculty.value}</span>
                                                                                            <button
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    this.removeParticipants(faculty);
                                                                                                }}
                                                                                                className="btn"
                                                                                            >
                                                                                                <i className="iCross_Rounded"
                                                                                                   style={{
                                                                                                       cursor: 'pointer',
                                                                                                       fontSize: '12px',
                                                                                                       color: '#698f8a',
                                                                                                       margin: '0px 0 0px 3px'
                                                                                                   }}/>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                        }
                                                                        <button type="button"
                                                                                disabled={this.state.faculties && this.state.faculties.length === 0}
                                                                                onClick={this.sendParticipantRequest}
                                                                                className="btn send">Send Invite
                                                                        </button>
                                                                        {this.state.subscriptionError &&
                                                                            <div className={"d-flex justify-content-center"}>
                                                                                <span style={{width: 'auto'}}
                                                                                    className="login-feedback-error mt-2">{this.state.subscriptionErrorMessage}</span>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div id="invalidNoOfOpenings" className="modal fade dgpopup confirmpop"
                                                     data-backdrop="static" data-keyboard="false">
                                                    <div className="modal-dialog">
                                                        <div className="modal-content">
                                                            <div className="modal-body">
                                                                <div className="newInvitepeopWrap">
                                                                    <button type="button" onClick={this.removefaculties}
                                                                            className="close" data-dismiss="modal"
                                                                            aria-label="Close"><span
                                                                        aria-hidden="true">&times;</span></button>
                                                                        <div className="pjaddjobsec">
                                                                            <p>
                                                                                No of openings became zero{this.props.projectDetail.creatorUserId !== this.state.userData.userId ? ". Contact Super Admin" : " please edit the project and increase no of openings "}
                                                                                {this.props.projectDetail.creatorUserId !== this.state.userData.userId && 
                                                                                    <a href="javascript:void(0)" onClick={(e) => { e.preventDefault();  this.sendMessageButtonClickModal(); }}>Send Message</a>
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>

                                    {this.state.sendMessageFlag &&
                                        <SendMessageModal profileId={this.props.projectDetail?.participationDetails?.creatorUserId}
                                                            userName={this.props.projectDetail?.participationDetails?.postedBy}
                                                            triggerMessageModalClose={this.triggerMessageModalCloseModal}/>
                                    }

                                    {this.state.participants && this.state.participants.length === 0 && this.state.type === 'FUNDRAISE' && !this.state.searchFlag &&
                                        <div className="zdata zfeed">
                                            <div className="imgbox">
                                                <img
                                                    src="https://cdn.dscovr.com/images/zroProjectsMyProject-new.webp"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src =
                                                        "https://cdn.dscovr.com/images/zroProjectsMyProject-new.png";
                                                    }}
                                                    alt=""
                                                    width={500}
                                                    />
                                            </div>
                                            <div className="desc">
                                                <p>You have no Contributors.</p>
                                            </div>
                                        </div>
                                    }

                                    <div className="row">
                                        {this.state.searchFlag && 
                                            <div className="col-md-12">
                                                <div className="searchByCard">
                                                    <form className="searchbox" onSubmit={this.handleSearchSubmit}>
                                                        <input type="text" className="search_query form-control" value={this.state.participantsSearchData} onChange={this.handleSearchParticipantsChange} placeholder="Search" autoComplete="off" maxLength={75}/>
                                                        {/* <button type="submit" name="submit_search" className="submit">Search</button> */}
                                                    </form>
                                                    {/* <span className="search-close" onClick={this.handleSearchClose.bind(this)}>Clear</span> */}
                                                </div>
                                            </div>
                                        }
                                        {this.state.participants && this.state.participants.length > 0 && this.state.participants.map((data, index) => {

                                            return <div className="col-md-6" key={index}>
                                                <div className="ownfollowblk" style={{margin: '0'}}>
                                                    <figure className="users" onClick={(e) => {e.preventDefault(); this.redirectToProfile(data.customUrl)}} style={{cursor: 'pointer'}}>
                                                        <img
                                                            src={!_.isNull(data.profileImage) && !_.isUndefined(data.profileImage) ? data.profileImage : (data.userType != "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                                                            alt=""/>
                                                    </figure>
                                                    <div>
                                                        <h5 onClick={(e) => {e.preventDefault(); this.redirectToProfile(data.customUrl)}} style={{cursor: 'pointer'}}>
                                                            {data.userName}
                                                        </h5>
                                                        <span className="pfollowlist">
                                                            <span>{!_.isUndefined(data.country) && !_.isNull(data.country) && data.country}</span>
                                                            <p>
                                                                {!_.isUndefined(data.persona) && !_.isNull(data.persona) && data.persona}
                                                            </p>
                                                        </span>
                                                    </div>
                                                    <AllowRestrictRemoveBtn userDetails={data} key={data.userId} onSuccessAllowRestrictPosting={this.onSuccessAllowRestrictPosting} activeTab={"PARTICIPANT"} projectType={this.props.type} donationEntityConfig={this.state.donationEntityConfig} />
                                                </div>
                                            </div>
                                        })}
                                        {this.state.responseMessage === "Success!" && this.state.participants && this.state.participants.length === 0 && this.state.searchFlag &&
                                            <SearchZeroDataSection />
                                        }
                                    </div>

                                    {this.state.pagination &&
                                        <div className="btnblock">
                                            <a href="javascript:void(0)" onClick={this.fetchMoreData}
                                            className="btn" data-toggle="modal">
                                                Show More
                                            </a>
                                        </div>
                                    }
                                </div>
                                }
                                {this.props.project &&  this.props.project.pendingInvitation && this.props.type === "JOB" &&
                                    <div className="circBecomeMember" style={{border: 'none'}}>
                                        <NavLink  to={{pathname: "/manage-invitation", state: {activeTab: "PROJECT"}}}
                                                className="btn bcmemb fixed"> Accept Invitation</NavLink>
                                    </div>
                                }
                            </div>
                            <RightPanel {...this.props}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (details) => dispatch(setProjectDetails(details)),
    };
};


export default connect(null, mapDispatchToProps)(ParticipantsContainer);
